import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ palette }) => ({
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '8px',
  },
  button: {
    flex: 1,
    padding: '6px 4px',
    borderRadius: '5px',
    backgroundColor: palette.primary.main,
    color: palette.common.white,

    '& span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
    },
  },
  buttonIcon: {
    fontSize: '16px',
    fill: palette.common.white,
  },
  loader: {
    '&.MuiCircularProgress-root': {
      color: `${palette.common.white} !important`,
    },
  },
}))
